import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subscription } from 'rxjs';
import { PASPrdService } from '../../../services/PASPrd.service';
import { ErrorStateMatcher1 } from '../../error-state-matcher1';
//import { IgrouppaslistResponse } from '../../Interfaces/igrouppas';
import { ILocationProductionResponse } from '../../Interfaces/ilocation';
//import { GRPASCCV1Detail } from '../../Interfaces/ipas';
import { AddPasOptionGroup, listPOGTypes, POGStatus, POGType } from '../../Interfaces/iproduction';


@Component({
  selector: 'app-optiongroupsadd',
  templateUrl: './optiongroupsadd.component.html'
})

export class OptionGroupsAddComponent implements OnInit {
  formedit: FormGroup;
  subRef$: Subscription;
  matcher = new ErrorStateMatcher1();
  message: string = "";
  //groups: IgrouppaslistResponse[];
  productionLocations: ILocationProductionResponse[];
  //dataCCs: GRPASCCV1Detail;
  //element: HTMLElement;
  //_TaxRegs: number = 0;

  constructor(
    private formBuilder: FormBuilder,
    //private locationService: LocationService,
    //private prdLocationService : PrdLocationService,
    //private pasService: PasService,
    private PASPrdService:PASPrdService,
//private ccService:CcService,
    private dialogRef: MatDialogRef<OptionGroupsAddComponent>,
    private _snackBar: MatSnackBar
  ) {
    this.formedit = formBuilder.group({
      code: ["", [Validators.required]],
      name: ["", [Validators.required]],
      type: [1, [Validators.required]],
      status: [1, [Validators.required]]
    });
  }
  //selectedvalue: number; selectedview: string;
  //codeSelect: string;
  listTypes: listPOGTypes[] = [{id: 1, name: 'Selección única' }, { id: 2, name: 'Selección  múltiple' }];

  ngOnInit() {
    this.message = "";
  }

  Cancel() {
    this.dialogRef.close();
  }

  Save() {
    try {
      let _Message = "";
      const _Data: AddPasOptionGroup = {
        code: this.formedit.value.code, status: (this.formedit.value.status == 1 ? POGStatus.ACTIVE : POGStatus.INACTIVE),
        name: this.formedit.value.name, type: (this.formedit.value.type == 1 ? POGType.UNIQUESELECTION : POGType.MULTIPLESELECTION)
      };
      this.PASPrdService.AddPOG(_Data).subscribe(result => {
            if (result.body.isValid) {
              _Message = "Grupo grabado";
              this.openSB(_Message);
            }
            else {
              alert(result.body.error.description);
              return;
            }
          }, (e) => {
            alert(e);
            return;
          });
        this.dialogRef.close(true);
    }
    catch (e) {
      console.log(e.message);
      alert(e.message);
    }
  }

  hasError(nombreControl: string, validacion: string) {
    const control = this.formedit.get(nombreControl);
    return control.hasError(validacion);
  }

  openSB(msg) {
    this._snackBar.open(msg, '', {
      duration: 3000, horizontalPosition: "center", verticalPosition: "top", panelClass: ['snackbarmsg']
    });
  }

  ngOnDestroy(): void {
  }
}
